import React from "react";
import { Button } from "react-bootstrap";
import styles from "./TrancheApproval.module.css";
import { GlobalModal } from "../../helper/GlobalModal";

const RejectTrancheModal = ({
  isOpen,
  onClose,
  rejectReason,
  setRejectReason,
  onReject,
  loading,
}) => {
  return (
    <GlobalModal
      isOpen={isOpen}
      title="Reject Tranche"
      onClose={onClose}
      size="md"
    >
      <div className={styles.modalContent}>
        <p className={styles.modalText}>
          Please provide a reason for rejecting this tranche.
        </p>
        <textarea
          className={styles.modalTextarea}
          rows={4}
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          placeholder="Enter reason..."
        />
        <div className={styles.modalActions}>
          <Button
            className="bg-gray-400 text-black"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button onClick={onReject} disabled={!rejectReason.trim() || loading}>
            Reject
          </Button>
        </div>
      </div>
    </GlobalModal>
  );
};

export default RejectTrancheModal;
